
<div class="input-icon-end position-relative">
  <input type="text" class="form-control date-range bookingrange" placeholder="dd/mm/yyyy - dd/mm/yyyy" bsDaterangepicker [(ngModel)]="bsRangeValue"  [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true }">
  <span class="input-icon-addon">
    <i class="ti ti-chevron-down"></i>
  </span>
</div>
